// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout */

.chat.session,
.chat.session .message-view {
  flex: 100 100 0%;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}

.chat.session .message-list {
  margin: 10px 10px 10px 0px;
}

.chat.session .message-view > .ui.message {
  margin: 10px 0px 0px 0px;
}

/* Messages common */
.chat.session .item .time {
  float: right;
  color: lightgray;
  font-size: small;
}

.chat.session .status.item > .text,
.chat.session .chat.item .left > .text {
  /* Avoid cutting text from the bottom with certain browser because of "overflow: hidden" */
  line-height: initial !important;

  overflow: hidden;
  white-space: pre-wrap;
  flex: 1;
}

/* Chat messages */
.chat.session .chat.item {
  margin-top: 5px;
}

.chat.session .chat.item .author {
  float: left;
}

.chat.session .chat.item .left {
  display: flex;
}

.chat.session .chat.item .left:not(.third-person) {
  flex-direction: column;
}

.chat.session .chat.item .left.third-person > .text {
  float: left;
  margin-left: 3px;
}

.chat.session .chat.item img {
  vertical-align: middle;
}

.chat.session .chat.item .third-person .author .ui.dropdown {
  margin-left: 3px;
}

.chat.session .chat.item .author .caption {
  color: steelblue !important;
}

.chat.session .chat.item.op .author .caption {
  color: darkgoldenrod !important;
}

.chat.session .chat.item.self .author .caption {
  color: black !important;
}

.chat.session .chat.item.bot .author .caption {
  color: rgba(0, 0, 0, 0.4) !important;
}

/* Status messages */
.chat.session .status.item {
  width: 100%;
  display: flex !important;
  flex-direction: row-reverse;
}

.chat.session .status.item > .text {
  font-size: small;
  color: rgba(0, 0, 0, 0.5);
  float: left;
}

.chat.session .status.item i {
  display: none !important;
}

.chat.session .status.item.verbose > .text {
  color: rgba(0, 0, 0, 0.4);
  font-size: x-small;
}

.chat.session .status.item.warning > .text {
  color: orange;
}

.chat.session .status.item.error > .text {
  color: red;
}

.chat.session .status.item.system > .text,
.chat.session .status.item.history > .text {
  font-style: italic;
  font-size: 85%;
}

.chat.session .status.item.private > .text {
  color: black;
  font-size: 85%;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Sidebar/components/chat/chat.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX;;EAEE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,0FAA0F;EAC1F,+BAA+B;;EAE/B,gBAAgB;EAChB,qBAAqB;EACrB,OAAO;AACT;;AAEA,kBAAkB;AAClB;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB","sourcesContent":["/* Layout */\n\n.chat.session,\n.chat.session .message-view {\n  flex: 100 100 0%;\n  display: flex;\n  flex-direction: column;\n  overflow-y: hidden;\n}\n\n.chat.session .message-list {\n  margin: 10px 10px 10px 0px;\n}\n\n.chat.session .message-view > .ui.message {\n  margin: 10px 0px 0px 0px;\n}\n\n/* Messages common */\n.chat.session .item .time {\n  float: right;\n  color: lightgray;\n  font-size: small;\n}\n\n.chat.session .status.item > .text,\n.chat.session .chat.item .left > .text {\n  /* Avoid cutting text from the bottom with certain browser because of \"overflow: hidden\" */\n  line-height: initial !important;\n\n  overflow: hidden;\n  white-space: pre-wrap;\n  flex: 1;\n}\n\n/* Chat messages */\n.chat.session .chat.item {\n  margin-top: 5px;\n}\n\n.chat.session .chat.item .author {\n  float: left;\n}\n\n.chat.session .chat.item .left {\n  display: flex;\n}\n\n.chat.session .chat.item .left:not(.third-person) {\n  flex-direction: column;\n}\n\n.chat.session .chat.item .left.third-person > .text {\n  float: left;\n  margin-left: 3px;\n}\n\n.chat.session .chat.item img {\n  vertical-align: middle;\n}\n\n.chat.session .chat.item .third-person .author .ui.dropdown {\n  margin-left: 3px;\n}\n\n.chat.session .chat.item .author .caption {\n  color: steelblue !important;\n}\n\n.chat.session .chat.item.op .author .caption {\n  color: darkgoldenrod !important;\n}\n\n.chat.session .chat.item.self .author .caption {\n  color: black !important;\n}\n\n.chat.session .chat.item.bot .author .caption {\n  color: rgba(0, 0, 0, 0.4) !important;\n}\n\n/* Status messages */\n.chat.session .status.item {\n  width: 100%;\n  display: flex !important;\n  flex-direction: row-reverse;\n}\n\n.chat.session .status.item > .text {\n  font-size: small;\n  color: rgba(0, 0, 0, 0.5);\n  float: left;\n}\n\n.chat.session .status.item i {\n  display: none !important;\n}\n\n.chat.session .status.item.verbose > .text {\n  color: rgba(0, 0, 0, 0.4);\n  font-size: x-small;\n}\n\n.chat.session .status.item.warning > .text {\n  color: orange;\n}\n\n.chat.session .status.item.error > .text {\n  color: red;\n}\n\n.chat.session .status.item.system > .text,\n.chat.session .status.item.history > .text {\n  font-style: italic;\n  font-size: 85%;\n}\n\n.chat.session .status.item.private > .text {\n  color: black;\n  font-size: 85%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
